import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { useAppContext } from "../../../_context";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { useState } from "react";

const Benefits = () => {
  const [idx, setIdx] = useState([]);
  const [{ tx: strings }] = useAppContext();
  const items = [
    {
      label: strings["Increased demand for your facilities"],
      body: strings[
        "The rapidly expanding RacketPal community is always on the lookout for the perfect venue to play. Get registered and make it even easier for players to find you."
      ],
    },
    {
      label: strings["Offer a digital platform for your members"],
      body: strings[
        "Give your members a quick and easy way to organise matches, meet other players and be part of an active community online and in person."
      ],
    },
    {
      label: strings["Organise online leagues and competitions"],
      body: strings[
        "Goodbye A4 sheets on a pinboard, hello RacketPal! Our app makes it quick and easy to set up and run leagues and competitions for your members."
      ],
    },
    {
      label: strings["Active players ready to book"],
      body: strings[
        "Our community of active players are constantly setting up new matches and booking court time. Don’t miss out."
      ],
    },
    {
      label: strings["Understand your members with data"],
      body: strings[
        "Get to know your members better through the power of data. Understand their playing habits and behaviour, and use that information to engage with them more effectively."
      ],
    },
  ];

  return (
    <section className="benefits-section">
      <Container>
        <Row>
          <Col md={8} className="m-auto">
            <h2 className="mb-5">{strings["Benefits for clubs"]}</h2>

            <Accordion defaultActiveKey={1}>
              {items.map((item, index) => {
                return (
                  <Card key={index + 1}>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey={index + 1}
                      onClick={() => {
                        if (idx.includes(index)) {
                          setIdx(idx.filter((i) => i !== index));
                        } else {
                          setIdx([index]);
                        }
                      }}
                      className="mb-0 py-3 cursor-pointer">
                      <h6 className="ps-5 mb-0 position-relative">
                        <span className="position-absolute left-0">
                          {idx.includes(index) ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )}
                        </span>
                        <span>{item.label}</span>
                      </h6>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={index + 1} className="ps-5">
                      <Card.Body>{item.body}</Card.Body>
                    </Accordion.Collapse>
                  </Card>
                );
              })}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Benefits;
